import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FileUploadComponent } from './file-upload.component';



@NgModule({
    declarations: [
      FileUploadComponent,
    ],
    imports     : [
       FuseSharedModule,

    ],
    exports: [
      FileUploadComponent,
    ],
    entryComponents: [
    ]
})

export class FileUploadModule
{

}
